import { render } from "./StepFive.vue?vue&type=template&id=04ab6b02&scoped=true"
import script from "./StepFive.vue?vue&type=script&lang=js"
export * from "./StepFive.vue?vue&type=script&lang=js"

import "./StepFive.vue?vue&type=style&index=0&id=04ab6b02&scoped=true&lang=css"

import exportComponent from "/var/www/extranet-sinistre-agemi/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ab6b02"]])

export default __exports__